var createAxisDelta = function createAxisDelta() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
};
var createDelta = function createDelta() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
};
var createAxis = function createAxis() {
  return {
    min: 0,
    max: 0
  };
};
var createBox = function createBox() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
export { createAxis, createAxisDelta, createBox, createDelta };